import { useQuery } from "@tanstack/react-query";
import { FollowCheckResponse } from "../../../types";
import { checkFollowStatusApi } from "../../../api/resources.api";

export const useFollowCheck = (type: "persons" | "projects", id?: number) => {
  return useQuery({
    queryKey: ["follow-check", type, id],
    enabled: !!id,
    queryFn: async () => {
      const response: FollowCheckResponse = await checkFollowStatusApi(
        type,
        id!,
      );

      if (typeof response?.is_following !== "boolean") {
        throw new Error("Invalid follow check response");
      }

      return response.is_following;
    },

    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
  });
};
